module.exports = __webpack_public_path__ + "static/media/13.963bbb59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/13.svg
// module id = 2804
// module chunks = 3